// @ts-nocheck
import { makeErrorToast, makeSuccessToast, msg } from '../../utils/makeToast'
import { createSlice, createAsyncThunk, nanoid, Reducer, PayloadAction } from '@reduxjs/toolkit'
import i18next from 'i18next'
import { DataStore, ModelInit, SortDirection } from '@aws-amplify/datastore'
import { API, graphqlOperation } from '@aws-amplify/api'
import { Projects, Quote, QuoteInfo, RecapInfo, Clients } from '../../models'
import { createQuoteTemplate } from '../../utils/quoteGridUtils/createQuoteUtil'
// import {
//   createRecapInfo,
//   refreshRecapInfo,
// } from '../../utils/recapGridUtils/createQuoteRecapInfoUtil'
import { getCreateQuoteRecapInfoUtil } from '@src/utils/recapGridUtils/createQuoteRecapInfoUtil/getCreateQuoteRecapInfoUtil'
import { isEqual, omit, pick } from 'lodash'
import * as mutations from '../../graphql/mutations'
import * as queries from '../../graphql/queries'
import { fetchProjectChildren, sortAndMegeProjectChildren } from './projects'
import { checkNumber, delay } from '../../utils/miscellaneous'
import {
  fetchQuoteInfoUtil,
  fetchQuotesByParentProjectIdUtil,
  fetchRecapInfoUtil,
  getFetchFilter,
  checkIfQuoteIsAccessible,
} from '../../utils/fetchUtils'
import {
  createCostLine,
  createCostLineIdsAndLabels,
} from '../../utils/quoteGridUtils/createQuoteUtil'

import {
  CreateQuoteMutationApi,
  CreateRecapInfoMutationApi,
  GetCompanyQueryApi,
  GetProjectsQueryApi,
  GetQuoteInfoQueryApi,
  GetQuoteQueryApi,
  ReduxProjects,
  ReduxQuote,
  ReduxQuoteInfo,
  ReduxQuoteInfoNewRow,
  ReduxRecapInfo,
  ReduxRecapInfoNewRow,
} from '@src/types/apiType'
import { RootState, ThunkAppDispatch, AppDispatch } from '@src/redux/store'
import { updatePurchase } from '@src/redux/slices/purchases'
import { updateCompanyInfo } from '@src/redux/slices/settings'

type ApiStatus = 'idle' | 'loading' | 'succeeded' | 'failed' | 'rejected'

interface QuoteState {
  currentQuote: ReduxQuote | null
  offlineQuotes: ReduxQuoteInfo[]
  oldQuoteInfo: ReduxQuoteInfo[]
  quoteInfo: ReduxQuoteInfo[]
  oldRecapQuoteInfo: ReduxRecapInfo[]
  recapQuoteInfo: ReduxRecapInfo[]
  calculateRecapInfoStatus: boolean
  createOrUpdateQuoteApiStatus: ApiStatus
  updateOfflineIdsStatus: ApiStatus
  deleteQuoteApiStatus: ApiStatus
  getOfflineQuotesApiStatus: ApiStatus
  fetchQuoteApiStatus: ApiStatus
  fetchQuoteInfoApiStatus: ApiStatus
  updateQuoteInfoApiStatus: ApiStatus
  fetchRecapQuoteInfoApiStatus: ApiStatus
  refreshRecapQuoteInfoApiStatus: ApiStatus
  updateRecapQuoteInfoApiStatus: ApiStatus
  duplicateQuoteApiStatus: ApiStatus
  moveQuoteApiStatus: ApiStatus
  uploadQuoteApiStatus: ApiStatus
  addOrRemoveSmgQuoteApiStatus: ApiStatus
  updateQuoteInfoDebounceApiStatus: ApiStatus
  updateRecapQuoteInfoDebounceApiStatus: ApiStatus
  updateQuoteInfoApiCounter: number
  updateRecapQuoteInfoApiCounter: number
  addQuoteModalOpenStatus: boolean
  quoteDeleteDialogOpenStatus: boolean
  quoteSummaryTotalsModalOpenStatus: boolean
  recapSummaryTotalsModalOpenStatus: boolean
  scrollToCategoryModalOpenStatus: boolean
  quotePdfGeneratorModalOpenStatus: boolean
  recapQuotePdfModalOpenStatus: boolean
  quoteDuplicateDialogOpenStatus: boolean
  quoteMoveDialogOpenStatus: boolean
  quoteSmgDialogStatus: { isOpen: boolean; section?: string | null }
  quoteEditModalStatus: { isOpen: boolean }
  summaryFetchQuoteStatus: ApiStatus
  scrollToCategory: string | null
  maximizeMinimize: 'maximize' | 'minimize'
  expandedRows: any
  filters: {
    item: string
    item_fr: string
    quantity?: number
    number?: number
    unit?: string
    rate?: number
    rateInEuros?: number
    total?: number
    payrollTaxType?: string
    payrollTaxEnabled?: string
    agentCommissionPercentage?: number
    marginPercentage?: number
    overheadPercentage?: number
    totalMargin?: number
  }
  smgMenuAnchorEl: any
  editQuoteMenuAnchorEl: any
  error?: string | null
}

const initialState: QuoteState = {
  currentQuote: null,
  offlineQuotes: [],
  oldQuoteInfo: [],
  quoteInfo: [],
  oldRecapQuoteInfo: [],
  recapQuoteInfo: [],
  calculateRecapInfoStatus: false,
  createOrUpdateQuoteApiStatus: 'idle',
  updateOfflineIdsStatus: 'idle',
  deleteQuoteApiStatus: 'idle',
  getOfflineQuotesApiStatus: 'idle',
  fetchQuoteApiStatus: 'idle',
  fetchQuoteInfoApiStatus: 'idle',
  updateQuoteInfoApiStatus: 'idle',
  fetchRecapQuoteInfoApiStatus: 'idle',
  refreshRecapQuoteInfoApiStatus: 'idle',
  updateRecapQuoteInfoApiStatus: 'idle',
  duplicateQuoteApiStatus: 'idle',
  moveQuoteApiStatus: 'idle',
  uploadQuoteApiStatus: 'idle',
  addOrRemoveSmgQuoteApiStatus: 'idle',
  updateQuoteInfoDebounceApiStatus: 'idle',
  updateRecapQuoteInfoDebounceApiStatus: 'idle',
  updateQuoteInfoApiCounter: 0,
  updateRecapQuoteInfoApiCounter: 0,
  addQuoteModalOpenStatus: false,
  quoteDeleteDialogOpenStatus: false,
  quoteSummaryTotalsModalOpenStatus: false,
  recapSummaryTotalsModalOpenStatus: false,
  scrollToCategoryModalOpenStatus: false,
  quotePdfGeneratorModalOpenStatus: false,
  recapQuotePdfModalOpenStatus: false,
  quoteDuplicateDialogOpenStatus: false,
  quoteMoveDialogOpenStatus: false,
  quoteSmgDialogStatus: { isOpen: false, section: null },
  quoteEditModalStatus: { isOpen: false },
  summaryFetchQuoteStatus: 'idle',
  scrollToCategory: null,
  maximizeMinimize: 'maximize',
  expandedRows: {},
  filters: {
    item: '',
    item_fr: '',
    quantity: 0,
    number: 0,
    unit: '',
    rate: 0,
    rateInEuros: 0,
    total: 0,
    payrollTaxType: '',
    payrollTaxEnabled: '',
    agentCommissionPercentage: 0,
    marginPercentage: 0,
    overheadPercentage: 0,
    totalMargin: 0,
  },
  smgMenuAnchorEl: null,
  editQuoteMenuAnchorEl: null,
  error: null,
}

export const fetchQuote = createAsyncThunk<
  ReduxQuote,
  { quoteId: string; page?: string; status?: string },
  {
    state: RootState
    rejectValue: string
  }
>('quote/fetchQuote', async ({ quoteId }, { getState, rejectWithValue }) => {
  try {
    const { auth } = getState()

    const quoteDetails = await DataStore.query(Quote, item =>
      item.id('eq', quoteId).activeFlag('eq', true)
    )
    const parsedQuote = JSON.parse(JSON.stringify(quoteDetails))

    const accessibleQuote: ReduxQuote = checkIfQuoteIsAccessible(auth.userInfo, parsedQuote[0])
    if (accessibleQuote) {
      return accessibleQuote as ReduxQuote
    } else {
      makeErrorToast(msg)
      return rejectWithValue('Error Fetching Quote')
    }
  } catch (err: any) {
    makeErrorToast(msg)
    return rejectWithValue(err)
  }
})

export const fetchQuoteInfo = createAsyncThunk<
  ReduxQuoteInfo[],
  { quoteId: string; page?: string },
  {
    state: RootState
    rejectValue: string
  }
>('quote/fetchQuoteInfo', async ({ quoteId }, { getState, rejectWithValue }) => {
  // Filter can be used along with sort as another parameter to datastore query
  try {
    const { auth } = getState()

    const quoteInfo = await DataStore.query(
      QuoteInfo,
      row => row.quoteId('eq', quoteId).activeFlag('eq', true),
      {
        sort: row => row.tableRowIndex(SortDirection.ASCENDING),
      }
    )
    const quoteInfoArray = JSON.parse(JSON.stringify(quoteInfo))
    //Data returned from datastore is in a model format we need to do this to make the data serializable

    return quoteInfoArray
  } catch (err: any) {
    makeErrorToast(msg)
    return rejectWithValue(err)
  }
})

export const fetchRecapQuoteInfo = createAsyncThunk<
  ReduxRecapInfo[] | null,
  { quoteId: string; calculateRecapInfo?: boolean },
  {
    state: RootState
    rejectValue: string
  }
>(
  'quote/fetchRecapQuoteInfo',
  async ({ quoteId, calculateRecapInfo }, { getState, rejectWithValue }) => {
    try {
      const { auth } = getState()
      const quoteFilter = getFetchFilter(auth.userInfo)

      const quoteData = await DataStore.query(Quote, c =>
        c.id('eq', quoteId).activeFlag('eq', true)
      )
      let parsedQuoteData = JSON.parse(JSON.stringify(quoteData))

      parsedQuoteData = checkIfQuoteIsAccessible(auth.userInfo, parsedQuoteData[0])

      const recapQuoteInfo = await DataStore.query(
        RecapInfo,
        row => row.quoteId('eq', quoteId).activeFlag('eq', true),
        {
          sort: row => row.tableRowIndex(SortDirection.ASCENDING),
        }
      )
      const parsedRecapInfo: ReduxRecapInfo[] = JSON.parse(JSON.stringify(recapQuoteInfo))
      let recapInfoArray: ReduxRecapInfo[] | null
      if (parsedRecapInfo.length === 0 && calculateRecapInfo) {
        const quoteInfo = await DataStore.query(
          QuoteInfo,
          row => row.quoteId('eq', quoteId).activeFlag('eq', true),
          {
            sort: row => row.tableRowIndex(SortDirection.ASCENDING),
          }
        )

        const parsedQuoteInfo: ReduxQuoteInfo[] = JSON.parse(JSON.stringify(quoteInfo))

        // const quoteDetails = await DataStore.query(Quote, c => c.id('eq', quoteId))
        // const parsedQuoteDetails = JSON.parse(JSON.stringify(quoteDetails))
        const tenantId = parsedQuoteData?.tenantId
        const { createRecapInfo } = getCreateQuoteRecapInfoUtil(
          parsedQuoteData?.quoteType as string
        )

        recapInfoArray = createRecapInfo(
          parsedQuoteInfo,
          quoteId,
          tenantId,
          parsedQuoteData?.childFreelancers as string[]
        )

        try {
          let items = recapInfoArray?.map(async item => {
            delete item.referenceCostLineUuid
            await DataStore.save(new RecapInfo(item as ModelInit<RecapInfo>))
          })
          // Checks if the items are not undefined
          items && (await Promise.all(items))
        } catch (err: any) {
          //If creating fails for even one recapInfo costline we need to delete the other recap Info costlines already created
          await delay(500)
          const recapQuoteInfo = await DataStore.query(RecapInfo, row =>
            row.quoteId('eq', quoteId).activeFlag('eq', true)
          )
          recapQuoteInfo.map(async item => {
            await DataStore.delete(item)
          })
          makeErrorToast(msg)
        }
        return recapInfoArray
      }
      return parsedRecapInfo
    } catch (err: any) {
      makeErrorToast(msg)
      return rejectWithValue(err)
    }
  }
)

export const createQuote = createAsyncThunk<
  void,
  { parentProjectId: string | null; quoteDetails: ReduxQuote; quoteType: string },
  {
    dispatch: AppDispatch
    state: RootState
    rejectValue: string
  }
>(
  'quote/createQuote',
  async (
    { parentProjectId = null, quoteDetails, quoteType },
    { dispatch, getState, rejectWithValue }
  ) => {
    try {
      const { auth, projects, settings } = getState()
      const existingData = projects.projectChildrenData as (ReduxProjects | ReduxQuote)[]
      const sort = settings.sort

      const parentProjectData = await DataStore.query(Projects, c =>
        c.id('eq', parentProjectId as string).activeFlag('eq', true)
      )
      const parsedParentProjectData = JSON.parse(JSON.stringify(parentProjectData))

      // * Checks if quote name exists within the parentProjectId reject and don't create quote
      const quoteData = await DataStore.query(Quote, c =>
        c.parentProjectId('eq', parentProjectId as string).activeFlag('eq', true)
      )
      const parsedQuoteData = JSON.parse(JSON.stringify(quoteData))

      if (parsedQuoteData.some((e: { name: string | undefined }) => e.name === quoteDetails.name)) {
        makeErrorToast('Quote Name already exists!')
        return rejectWithValue('Quote Name already exists!')
      }
      // * We have spread the quote details early becuase of TS if this causes an issue later check it
      const updatedQuoteDetails = {
        ...quoteDetails,
        id: nanoid(),
        tenantId: parsedParentProjectData[0]?.tenantId,
        activeFlag: true,
        type: 'quote',
        isStarred: false,
        parentProjectId,
        freelancers: ['dummyId'],
        childFreelancers: [...(parsedParentProjectData[0]?.childFreelancers || ['dummyId'])],
        offlineIds: ['dummyId'],
        quoteType: quoteType,
        marginPercentage: parseInt(quoteDetails.marginPercentage as unknown as string),
        overheadPercentage: parseInt(quoteDetails.overheadPercentage as unknown as string),
        exchangeRate: parseInt(quoteDetails.exchangeRate as unknown as string),
      }

      //*  Saves the quote first
      const {
        data: { createQuote: newQuote },
      } = (await API.graphql(
        graphqlOperation(mutations.createQuote, { input: updatedQuoteDetails })
      )) as { data: CreateQuoteMutationApi }
      // const newQuote = await DataStore.save(new Quote(updatedQuoteDetails as Quote))
      // console.log('newQuote: ', newQuote)

      // * Saves the quoteInfo next
      // Gets an array of all the costlines
      await API.graphql(
        graphqlOperation(mutations.createQuoteInfoCostlines, {
          input: {
            quoteId: updatedQuoteDetails.id,
            tenantId: updatedQuoteDetails.tenantId,
            allowInternational: updatedQuoteDetails.allowInternational,
            exchangeRate: updatedQuoteDetails.exchangeRate,
            marginPercentage: updatedQuoteDetails.marginPercentage,
            overheadPercentage: updatedQuoteDetails.overheadPercentage,
          },
          quoteType: quoteType,
        })
      )
      // Keeping a small window before project children are fetched because if called immediately datastore doesn't fetch the changes of api mutation
      // Get a list of all parentProjectIds children after saving the new project
      // dispatch(fetchProjectChildren({ parentProjectId: parentProjectId as string }))

      const projectChildren = [...existingData, newQuote]
      dispatch(sortAndMegeProjectChildren({ projectChildren, sort }))

      return
    } catch (err: any) {
      makeErrorToast(msg)
      return rejectWithValue(err)
    }
  }
)

export const updateQuote = createAsyncThunk<
  void,
  { quoteId: string; newQuote: ReduxQuote; modifier?: string },
  {
    dispatch: ThunkAppDispatch
    state: RootState
    rejectValue: string
  }
>(
  'quote/updateQuote',
  async ({ quoteId, newQuote, modifier }, { dispatch, getState, rejectWithValue }) => {
    try {
      const { auth } = getState()
      // Gets the og quote

      const quoteDetails = await DataStore.query(Quote, item =>
        item.id('eq', quoteId).activeFlag('eq', true)
      )
      const parsedQuote = JSON.parse(JSON.stringify(quoteDetails))
      let originalQuote = checkIfQuoteIsAccessible(auth.userInfo, parsedQuote[0])
      if (!originalQuote) {
        return rejectWithValue(`Can't update quote`)
      }
      let quoteUpdateParams = {} as ReduxQuote
      quoteUpdateParams.id = originalQuote.id
      quoteUpdateParams._version = originalQuote._version

      const updatedQuote = await DataStore.save(
        Quote.copyOf(quoteDetails[0], original => {
          for (const property in newQuote) {
            const typedProperty = property as keyof ReduxQuote
            if (!isEqual(newQuote[typedProperty], original[typedProperty])) {
              original[typedProperty] = newQuote[typedProperty] as any
            }
          }
        })
      )
      const parsedUpdatedQuote = JSON.parse(JSON.stringify(updatedQuote))

      for (const property in newQuote) {
        const typedProperty = property as keyof ReduxQuote
        if (!isEqual(newQuote[typedProperty], originalQuote[typedProperty])) {
          quoteUpdateParams[typedProperty] = newQuote[typedProperty] as any
        }
      }
      //* can't change these values
      delete quoteUpdateParams.recapInfo
      delete quoteUpdateParams.quoteInfo
      delete quoteUpdateParams.proposals
      delete quoteUpdateParams.freelancers
      delete quoteUpdateParams.childFreelancers
      delete quoteUpdateParams._deleted
      delete quoteUpdateParams._lastChangedAt
      delete quoteUpdateParams.allowInternational
      delete quoteUpdateParams.updatedOn

      const updateGlobalMargins = quoteUpdateParams.hasOwnProperty('marginPercentage')
      const updateGlobalOverheads = quoteUpdateParams.hasOwnProperty('overheadPercentage')
      const updateGlobalExchangeRate = quoteUpdateParams.hasOwnProperty('exchangeRate')
      if (updateGlobalMargins || updateGlobalOverheads || updateGlobalExchangeRate) {
        await API.graphql(
          graphqlOperation(mutations.updateQuoteMarginsAndOverhead, {
            quoteId,
            updateGlobalMargins,
            updateGlobalOverheads,
            updateGlobalExchangeRate,
          })
        )
        await API.graphql(
          graphqlOperation(mutations.calculateMarginsAndTotals, {
            quoteId,
          })
        )
        dispatch(fetchQuoteInfo({ quoteId }))
      }
      // Get a list of all parentProjectIds children after saving the new project
      // dispatch(
      //   fetchProjectChildren({ parentProjectId: parsedUpdatedQuote?.parentProjectId as string })
      // )
      dispatch(getOfflineQuotes({ userId: auth.userInfo.username }))
      dispatch(setCurrentQuote(parsedUpdatedQuote))
      if (modifier === 'updateProjectChildren' || modifier === 'showToast') {
        // Get a list of all parentProjectIds children after saving the new project
        dispatch(
          fetchProjectChildren({ parentProjectId: parsedUpdatedQuote?.parentProjectId as string })
        )
      }

      if (modifier === 'showToast')
        makeSuccessToast(i18next.t('projectChildren:quote:successMsg:update'))
    } catch (err: any) {
      makeErrorToast(msg)
      return rejectWithValue(err)
    }
  }
)

export const toggleQuoteOffline = createAsyncThunk<
  void,
  { quoteId: string },
  {
    dispatch: ThunkAppDispatch
    state: RootState
    rejectValue: string
  }
>('quote/toggleQuoteOffline', async ({ quoteId }, { dispatch, getState, rejectWithValue }) => {
  try {
    const { auth }: any = getState()
    // Gets the og quote
    let {
      data: { getQuote: originalQuote },
    } = (await API.graphql(graphqlOperation(queries.getQuote, { id: quoteId }))) as {
      data: GetQuoteQueryApi
    }
    originalQuote = checkIfQuoteIsAccessible(auth.userInfo, originalQuote)
    if (!originalQuote) {
      return rejectWithValue(`Can't update quote`)
    }
    let quoteUpdateParams = {} as ReduxQuote
    quoteUpdateParams.id = originalQuote.id
    quoteUpdateParams._version = originalQuote._version

    // quoteUpdateParams.offlineIds = originalQuote.offlineIds.push(auth.userInfo.username as string)
    if (originalQuote.offlineIds?.includes(auth.userInfo.username)) {
      await API.graphql(
        graphqlOperation(mutations.removeOfflineIds, {
          quoteId,
          username: auth.userInfo.username,
        })
      )
    } else {
      await API.graphql(
        graphqlOperation(mutations.addOfflineIds, {
          quoteId,
          username: auth.userInfo.username,
        })
      )
    }
    // const {
    //   data: { updateQuote: parsedUpdatedQuote },
    // } = (await API.graphql(
    //   graphqlOperation(mutations.updateQuote, { input: quoteUpdateParams })
    // )) as {
    //   data: UpdateQuoteMutationApi
    // }
    // // Get a list of all parentProjectIds children after saving the new project
    dispatch(fetchProjectChildren({ parentProjectId: originalQuote?.parentProjectId as string }))

    makeSuccessToast(i18next.t('projectChildren:quote:successMsg:update'))
  } catch (err: any) {
    makeErrorToast(msg)
    return rejectWithValue(err)
  }
})

export const updateQuoteInfo = createAsyncThunk<
  ReduxQuoteInfo[],
  ReduxQuoteInfo[],
  {
    state: RootState
    rejectValue: string
  }
>('quote/updateQuoteInfo', async (rows, { getState, rejectWithValue }) => {
  try {
    const updatedRows = []
    const { quotes } = getState()
    const previousRows = quotes.oldQuoteInfo
    // * We are using an array to store promises of all rows that need to be updated or added
    const updateOrNewCostlinePromises = []
    for (let i = 0; i < rows.length; i++) {
      // * new row is not a field in graphql schema it just to check if a newRow has been added
      const eachRow = rows[i]
      // We are using newRows to update the redux state with the new row values, For lines that were updated we need to replace the index number with the updated or added rows
      // First we check if the redux row for quote Info is the same
      if (!isEqual(eachRow, previousRows[i])) {
        //*  We are removing version, last changed, at from the rows when comparing because version field should not be updated by user.
        const { _version: v2, _lastChangedAt: l2, ...copyUpdatedRow } = eachRow
        const updatePromise = async () => {
          const originalRow = await DataStore.query(QuoteInfo, eachRow.id as string)

          if (originalRow) {
            // updates the og quote and saves it
            const updatedRow = await DataStore.save(
              QuoteInfo.copyOf(originalRow, original => {
                for (const property in copyUpdatedRow) {
                  // Only updates the property that is different
                  if (!isEqual(copyUpdatedRow[property], original[property])) {
                    original[property] = copyUpdatedRow[property]
                  }
                }
              })
            )

            return updatedRow
          }

          // updatedRows.push(updatedRow)
        }
        updateOrNewCostlinePromises.push(updatePromise())
      } else {
        updatedRows.push(eachRow)
      }
    }
    // All promise are executed at once
    await Promise.all(updateOrNewCostlinePromises)

    return rows
  } catch (err: any) {
    makeErrorToast(msg)
    return rejectWithValue(err)
  }
})

export const addQuoteInfoCostline = createAsyncThunk<
  void,
  ReduxQuoteInfoNewRow[],
  {
    state: RootState
    dispatch: ThunkAppDispatch
    rejectValue: string
  }
>('quote/addQuoteInfoCostline', async (rows, { getState, dispatch, rejectWithValue }) => {
  try {
    const { quotes } = getState()
    const previousRows = quotes.oldQuoteInfo
    // * We are using an array to store promises of all rows that need to be updated or added
    const updateOrNewCostlinePromises = []
    let newRows = []
    for (let i = 0; i < rows.length; i++) {
      // * new row is not a field in graphql schema it just to check if a newRow has been added
      const { newRow = false, ...eachRow } = rows[i]

      // We are using newRows to update the redux state with the new row values, For lines that were updated we need to replace the index number with the updated or added rows
      newRows.push(eachRow)
      // First we check if the redux row for quote Info is the same
      if (!isEqual(eachRow, previousRows[i])) {
        //*  We are removing version, last changed, at from the rows when comparing because version field should not be updated by user.
        if (!newRow) {
          const { _version: v2, _lastChangedAt: l2, ...copyUpdatedRow } = eachRow
          const updatePromise = async () => {
            const originalRow = await DataStore.query(QuoteInfo, eachRow.id as string)
            const parsedOriginalRow = JSON.parse(JSON.stringify(originalRow)) as ReduxQuoteInfo
            if (parsedOriginalRow) {
              const updatedRow = await DataStore.save(
                QuoteInfo.copyOf(originalRow, original => {
                  for (const property in copyUpdatedRow) {
                    // Only updates the property that is different
                    if (!isEqual(copyUpdatedRow[property], original[property])) {
                      original[property] = copyUpdatedRow[property]
                    }
                  }
                })
              )

              // let updateDetails = {} as ReduxQuoteInfo
              // for (const property in parsedOriginalRow) {
              //   const typedProperty = property as keyof ReduxQuoteInfo
              //   if (!isEqual(parsedOriginalRow[typedProperty], eachRow[typedProperty])) {
              //     updateDetails[typedProperty] = eachRow[typedProperty] as any
              //   }
              // }
              // const { createdAt, updatedAt, _lastChangedAt, _deleted, ...parsedUpdatedDetails } =
              //   updateDetails
              // parsedUpdatedDetails.id = parsedOriginalRow.id
              // parsedUpdatedDetails._version = parsedOriginalRow._version

              // await API.graphql(
              //   graphqlOperation(mutations.updateQuoteInfo, { input: parsedUpdatedDetails })
              // )
            }
          }
          updateOrNewCostlinePromises.push(updatePromise())
        } else {
          // Creates a new quote if the there is a newRow field exists in the action arg
          const newRowPromise = async () => {
            let item = {
              ...eachRow,
              freelancers: ['dummyId'],
              childFreelancers: [...(quotes.oldQuoteInfo[0].childFreelancers || ['dummyId'])],
              offlineIds: ['dummyId'],
            }
            await DataStore.save(new QuoteInfo(item as ModelInit<QuoteInfo>))
          }
          updateOrNewCostlinePromises.push(newRowPromise())
        }
      }
    }
    // All promise are executed at once
    try {
      await Promise.all(updateOrNewCostlinePromises)
    } catch (err: any) {
      makeErrorToast(msg)
    }
    if (rows[0].quoteId) {
      dispatch(fetchQuoteInfo({ quoteId: rows[0].quoteId }))
    }
  } catch (err: any) {
    makeErrorToast(msg)
    return rejectWithValue(err)
  }
})

export const addRecapQuoteInfoCostline = createAsyncThunk<
  ReduxRecapInfo[],
  ReduxRecapInfoNewRow[],
  {
    state: RootState
    dispatch: ThunkAppDispatch
    rejectValue: string
  }
>('quote/addRecapQuoteInfoCostline', async (rows, { getState, dispatch, rejectWithValue }) => {
  try {
    const { auth, quotes } = getState()
    const quoteFilter = getFetchFilter(auth.userInfo)
    const updatedRows = []

    const datastoreRecapQuoteInfo = await DataStore.query(
      RecapInfo,
      row => row.quoteId('eq', quotes?.currentQuote?.id as string).activeFlag('eq', true),
      {
        sort: row => row.tableRowIndex(SortDirection.ASCENDING),
      }
    )
    const previousRows: ReduxRecapInfo[] = JSON.parse(JSON.stringify(datastoreRecapQuoteInfo))
    const updateOrNewCostlinePromises = []
    let newRows = []
    for (let i = 0; i < rows.length; i++) {
      const { newRow = false, ...eachRow } = rows[i]
      newRows.push(eachRow)
      const originalRow = previousRows.find(row => row.id === eachRow.id)
      if (originalRow) {
        if (!isEqual(eachRow, originalRow) && !newRow) {
          const { _version: v2, _lastChangedAt: l2, ...copyUpdatedRow } = eachRow
          // const updatePromise = async () => {
          //   const updatedRow = {} as ReduxRecapInfo
          //   for (const property in copyUpdatedRow) {
          //     const typedProperty = property as keyof typeof copyUpdatedRow
          //     // Only updates the property that is different
          //     if (!isEqual(copyUpdatedRow[typedProperty], originalRow[typedProperty])) {
          //       updatedRow[typedProperty] = copyUpdatedRow[typedProperty] as any
          //     }
          //   }
          //   // We need to send version & id with every update request
          //   updatedRow.id = originalRow.id
          //   updatedRow._version = originalRow._version
          //   delete updatedRow._deleted
          //   delete updatedRow._lastChangedAt
          //   delete updatedRow.createdAt
          //   delete updatedRow.updatedAt
          //   delete updatedRow.uuid

          //   const {
          //     data: { updateRecapInfo: apiUpdatedRow },
          //   } = (await API.graphql(
          //     graphqlOperation(mutations.updateRecapInfo, { input: updatedRow })
          //   )) as { data: UpdateRecapInfoMutationApi }

          const updatePromise = async () => {
            const newOriginalRow = await DataStore.query(RecapInfo, eachRow.id as string)
            const parsedOriginalRow = JSON.parse(JSON.stringify(originalRow)) as ReduxQuoteInfo
            const updatedRow = await DataStore.save(
              RecapInfo.copyOf(newOriginalRow, original => {
                for (const property in copyUpdatedRow) {
                  // Only updates the property that is different
                  if (!isEqual(copyUpdatedRow[property], original[property])) {
                    original[property] = copyUpdatedRow[property]
                  }
                }
              })
            )

            return updatedRow
          }
          updateOrNewCostlinePromises.push(updatePromise())
        } else {
          updatedRows.push(eachRow)
          console.count('Non updated Rows')
        }
      } else if (newRow) {
        const apiNewRow = await DataStore.save(new RecapInfo(eachRow as ModelInit<RecapInfo>))
        const parsedApiNewRow = JSON.parse(JSON.stringify(apiNewRow))
        newRows[i] = parsedApiNewRow
      }
    }
    await Promise.all(updateOrNewCostlinePromises)
    await delay(200)
    const recapQuoteInfo = await DataStore.query(
      RecapInfo,
      row => row.quoteId('eq', quotes?.currentQuote?.id as string).activeFlag('eq', true),
      {
        sort: row => row.tableRowIndex(SortDirection.ASCENDING),
      }
    )
    const parsedRecapInfo: ReduxRecapInfo[] = JSON.parse(JSON.stringify(recapQuoteInfo))

    return parsedRecapInfo
  } catch (err: any) {
    makeErrorToast(msg)
    return rejectWithValue(err)
  }
})

export const updateRecapQuoteInfo = createAsyncThunk<
  ReduxRecapInfo[],
  ReduxRecapInfoNewRow[],
  {
    state: RootState
    dispatch: ThunkAppDispatch
    rejectValue: string
  }
>('quote/updateRecapQuoteInfo', async (rows, { getState, dispatch, rejectWithValue }) => {
  try {
    const { auth, quotes } = getState()
    const quoteFilter = getFetchFilter(auth.userInfo)
    const updatedRows = []

    const oldRecapQuoteInfo = await DataStore.query(
      RecapInfo,
      row => row.quoteId('eq', quotes?.currentQuote?.id as string).activeFlag('eq', true),
      {
        sort: row => row.tableRowIndex(SortDirection.ASCENDING),
      }
    )
    const previousRows: ReduxRecapInfo[] = JSON.parse(JSON.stringify(oldRecapQuoteInfo))

    const updateOrNewCostlinePromises = []
    let newRows = [] as ReduxRecapInfo[]
    for (let i = 0; i < rows.length; i++) {
      const { newRow = false, ...eachRow } = rows[i]
      newRows.push(eachRow)
      const originalRow = previousRows.find(row => row.id === eachRow.id)
      if (originalRow) {
        if (!isEqual(eachRow, originalRow) && !newRow) {
          const { _version: v2, _lastChangedAt: l2, ...copyUpdatedRow } = eachRow
          const updatePromise = async () => {
            // const updatedRow = {} as ReduxRecapInfo
            // for (const property in copyUpdatedRow) {
            //   const typedProperty = property as keyof typeof copyUpdatedRow
            //   // Only updates the property that is different
            //   if (!isEqual(copyUpdatedRow[typedProperty], originalRow[typedProperty])) {
            //     updatedRow[typedProperty] = copyUpdatedRow[typedProperty] as any
            //   }
            // }
            // // We need to send version & id with every update request
            // updatedRow.id = originalRow.id
            // updatedRow._version = originalRow._version
            // delete updatedRow._deleted
            // delete updatedRow._lastChangedAt
            // delete updatedRow.createdAt
            // delete updatedRow.updatedAt
            // delete updatedRow.uuid

            // const {
            //   data: { updateRecapInfo: apiUpdatedRow },
            // } = (await API.graphql(
            //   graphqlOperation(mutations.updateRecapInfo, { input: updatedRow })
            // )) as { data: UpdateRecapInfoMutationApi }

            const originalRow = await DataStore.query(RecapInfo, eachRow.id as string)

            if (originalRow) {
              // updates the og quote and saves it
              const updatedRow = await DataStore.save(
                RecapInfo.copyOf(originalRow, original => {
                  for (const property in copyUpdatedRow) {
                    // Only updates the property that is different
                    if (!isEqual(copyUpdatedRow[property], original[property])) {
                      original[property] = copyUpdatedRow[property]
                    }
                  }
                })
              )
              return updatedRow
            }
          }
          updateOrNewCostlinePromises.push(updatePromise())
        } else if (newRow) {
          const apiNewRow = await DataStore.save(new RecapInfo(eachRow as ModelInit<RecapInfo>))
          const parsedApiNewRow = JSON.parse(JSON.stringify(apiNewRow))
          if (parsedApiNewRow) {
            newRows[i] = parsedApiNewRow
          }
        } else {
          updatedRows.push(eachRow)
        }
      }
    }
    await Promise.all(updateOrNewCostlinePromises)
    return newRows
  } catch (err: any) {
    makeErrorToast(msg)
    return rejectWithValue(err)
  }
})

export const deleteQuote = createAsyncThunk<
  void,
  { quote: ReduxQuote },
  {
    dispatch: ThunkAppDispatch
    rejectValue: string
  }
>('quote/deleteQuote', async ({ quote }, { dispatch, rejectWithValue }) => {
  try {
    await API.graphql(graphqlOperation(mutations.deleteQuoteById, { quoteId: quote.id }))
    dispatch(fetchProjectChildren({ parentProjectId: quote.parentProjectId as string }))
  } catch (err: any) {
    makeErrorToast(msg)
    return rejectWithValue(err)
  }
})

export const refreshRecapQuoteInfo = createAsyncThunk<
  void,
  string,
  {
    state: RootState
    dispatch: ThunkAppDispatch
    rejectValue: string
  }
>('quote/refreshRecapQuoteInfo', async (quoteId, { dispatch, getState, rejectWithValue }) => {
  try {
    const { auth } = getState()
    const quoteFilter = getFetchFilter(auth.userInfo)
    const recapQuoteInfo = await DataStore.query(
      RecapInfo,
      row => row.quoteId('eq', quoteId).activeFlag('eq', true),
      {
        sort: row => row.tableRowIndex(SortDirection.ASCENDING),
      }
    )
    const parsedRecapInfo = JSON.parse(JSON.stringify(recapQuoteInfo))
    if (parsedRecapInfo && parsedRecapInfo.length > 0) {
      const quoteInfo = await DataStore.query(
        QuoteInfo,
        row => row.quoteId('eq', quoteId).activeFlag('eq', true),
        {
          sort: row => row.tableRowIndex(SortDirection.ASCENDING),
        }
      )
      const parsedQuoteInfo = JSON.parse(JSON.stringify(quoteInfo))

      const quoteDetails = await DataStore.query(Quote, c =>
        c.id('eq', quoteId).activeFlag('eq', true)
      )
      let parsedQuoteDetails = JSON.parse(JSON.stringify(quoteDetails))
      parsedQuoteDetails = checkIfQuoteIsAccessible(auth.userInfo, parsedQuoteDetails[0])
      const { refreshRecapInfo } = getCreateQuoteRecapInfoUtil(
        parsedQuoteDetails?.quoteType as string
      )
      if (parsedQuoteDetails) {
        const tenantId = parsedQuoteDetails?.tenantId
        const refreshRecapInfoArray = refreshRecapInfo(
          parsedQuoteInfo,
          parsedRecapInfo,
          quoteId,
          tenantId,
          parsedQuoteDetails.childFreelancers as string[]
        )
        const refreshRecapInfoPromiseArray = [] as any[]
        refreshRecapInfoArray.map(async row => {
          const refreshRecapPromise = async () => {
            // If recap quote id exists just update the recap costline
            // If recap quote id doesn't exist create the costlines
            const originalRow = await DataStore.query(RecapInfo, row.id as string)
            const existingRecapCostline = parsedRecapInfo.find(
              (recapCostline: { id: string | undefined }) => recapCostline.id === row.id
            )
            if (existingRecapCostline && Object.keys(existingRecapCostline).length > 0) {
              // only updates if the row being updated is different from row fetched from the datastore
              if (!isEqual(existingRecapCostline, row)) {
                const updateInput = {} as ReduxRecapInfo
                for (const property in row) {
                  const typedProperty = property as keyof typeof row
                  // Only updates the property that is different
                  if (!isEqual(row[typedProperty], existingRecapCostline[typedProperty])) {
                    updateInput[typedProperty] = row[typedProperty] as any
                  }
                }
                updateInput.id = existingRecapCostline.id
                updateInput._version = existingRecapCostline._version
                delete updateInput._deleted
                delete updateInput._lastChangedAt
                delete updateInput.createdAt
                delete updateInput.updatedAt
                delete updateInput.uuid

                // const {
                //   data: { updateRecapInfo: updatedRow },
                // } = (await API.graphql(
                //   graphqlOperation(mutations.updateRecapInfo, { input: updateInput })
                // )) as { data: UpdateRecapInfoMutationApi }

                const updatedRow = await DataStore.save(
                  RecapInfo.copyOf(originalRow, original => {
                    for (const property in row) {
                      // Only updates the property that is different
                      if (!isEqual(row[property], original[property])) {
                        original[property] = row[property]
                      }
                    }
                  })
                )
              }
            } else {
              delete row.referenceCostLineUuid

              await DataStore.save(new RecapInfo(row as ModelInit<RecapInfo>))
            }
          }
          refreshRecapInfoPromiseArray.push(refreshRecapPromise())
        })
        await Promise.all(refreshRecapInfoPromiseArray)
        dispatch(fetchRecapQuoteInfo({ quoteId }))
      }
    } else {
      // * If recapInfo doesn't have items we do not use refreshRecap
      return
    }
  } catch (err: any) {
    makeErrorToast(msg)
    return rejectWithValue(err)
  }
})

export const duplicateQuote = createAsyncThunk<
  void,
  { quoteId: string; bidLetter: boolean; recapTable: boolean },
  {
    state: RootState
    dispatch: ThunkAppDispatch
    rejectValue: string
  }
>(
  'quote/duplicateQuote',
  async ({ quoteId, bidLetter, recapTable }, { dispatch, getState, rejectWithValue }) => {
    /*
     * Fetch Quote Details, QuoteInfo & recapQuoteInfo details
     * Create a new name for the quote, remove id, createdAt, updatedAt & isStarred.
     * Save Quote Details first, use the id from quote details to update quoteId field of QuoteInfo & recapQuoteInfo
     * Remove version from QuoteInfo & recapQuoteInfo
     * Use Promise.all to parallel create all the new quoteInfo & recapQuoteInfo items
     * Add quote as part of parentProject
     */
    try {
      const { auth } = getState()
      let {
        data: { getQuote: parsedOriginalQuoteDetails },
      } = (await API.graphql(graphqlOperation(queries.getQuote, { id: quoteId }))) as {
        data: GetQuoteQueryApi
      }
      parsedOriginalQuoteDetails = checkIfQuoteIsAccessible(
        auth.userInfo,
        parsedOriginalQuoteDetails
      )

      await API.graphql(
        graphqlOperation(mutations.duplicateQuote, {
          quoteId: quoteId,
          bidLetter,
          recapTable,
        })
      )
      // Get a list of all parentProjectIds children after saving the new project
      dispatch(
        fetchProjectChildren({
          parentProjectId: parsedOriginalQuoteDetails?.parentProjectId as string,
        })
      )
      makeSuccessToast(i18next.t('projectChildren:quote:successMsg:duplicate'))

      //* Update Duplicate Counter
      // @ts-ignore
      const tenantId = auth.userInfo.tenantId
      const {
        data: { getCompany: oldCompanyInfoDetails },
      } = (await API.graphql(graphqlOperation(queries.getCompany, { id: tenantId }))) as {
        data: GetCompanyQueryApi
      }
      const updatedCompanyInfoDetails = {
        id: tenantId,
        duplicateQuoteCounter: oldCompanyInfoDetails?.duplicateQuoteCounter
          ? oldCompanyInfoDetails?.duplicateQuoteCounter + 1
          : 1,
        _version: oldCompanyInfoDetails?._version,
      }
      await API.graphql(
        graphqlOperation(mutations.updateCompany, { input: updatedCompanyInfoDetails })
      )
    } catch (err: any) {
      makeErrorToast(msg)
      return rejectWithValue(err)
    }
  }
)

export const moveQuote = createAsyncThunk<
  void,
  { quoteId: string; parentProjectId: string; currentParentProjectId: string },
  {
    dispatch: ThunkAppDispatch
    rejectValue: string
  }
>(
  'quote/moveQuote',
  async ({ quoteId, parentProjectId, currentParentProjectId }, { dispatch, rejectWithValue }) => {
    try {
      await API.graphql(
        graphqlOperation(mutations.moveQuote, {
          quoteId: quoteId,
          parentProjectId: parentProjectId,
        })
      )
      dispatch(fetchProjectChildren({ parentProjectId: currentParentProjectId }))

      makeSuccessToast(i18next.t('projectChildren:quote:successMsg:move'))
      dispatch(setCurrentQuote(null))
      dispatch(setQuoteMoveDialogOpenStatus(false))
    } catch (err: any) {
      makeErrorToast(msg)
      return rejectWithValue(err)
    }
    // Closes modal when successful
  }
)

export const removeQuoteSmg = createAsyncThunk<
  void,
  { quoteId: string },
  {
    state: RootState
    dispatch: ThunkAppDispatch
    rejectValue: string
  }
>('quote/removeQuoteSmg', async ({ quoteId }, { dispatch, getState, rejectWithValue }) => {
  try {
    const { auth } = getState()
    const quoteFilter = getFetchFilter(auth.userInfo)
    const parsedQuoteInfo: ReduxQuoteInfo[] = await fetchQuoteInfoUtil(quoteId, quoteFilter)
    const updatedRows = [] as ReduxQuoteInfo[]
    const updateAllCostlinepromises = []
    parsedQuoteInfo.map(costline => {
      if (costline.smg === null) {
        return costline
      }
      // Sets rate to null in costlines that has smg field and it's qt and nb fields are empty
      if (costline.rate === costline.smg && !costline.number && !costline.quantity) {
        costline.rate = null
        // We are keeping track of updated costlines in an array
        updatedRows.push(costline)
      }
      return costline
    })
    for (let i = 0; i < updatedRows.length; i++) {
      const updatePromise = async () => {
        const data = (await API.graphql(
          graphqlOperation(queries.getQuoteInfo, { id: updatedRows[i].id })
        )) as { data: GetQuoteInfoQueryApi }
        const originalRow = data.data.getQuoteInfo
        if (originalRow) {
          const updateDetails = {
            id: originalRow.id,
            rate: null,
            _version: originalRow._version,
          }
          const updatedRow = await API.graphql(
            graphqlOperation(mutations.updateQuoteInfo, { input: updateDetails })
          )
          return updatedRow
        }
      }
      updateAllCostlinepromises.push(updatePromise())
    }
    const updatedValue = await Promise.allSettled(updateAllCostlinepromises)
    dispatch(fetchQuoteInfo({ quoteId }))
    return
  } catch (err: any) {
    makeErrorToast(msg)
    return rejectWithValue(err)
  }
})

export const addQuoteSmg = createAsyncThunk<
  void,
  { quoteId: string },
  {
    state: RootState
    dispatch: ThunkAppDispatch
    rejectValue: string
  }
>('quote/addQuoteSmg', async ({ quoteId }, { dispatch, getState, rejectWithValue }) => {
  try {
    const { auth } = getState()
    const quoteFilter = getFetchFilter(auth.userInfo)
    const parsedQuoteInfo: ReduxQuoteInfo[] = await fetchQuoteInfoUtil(quoteId, quoteFilter)

    const updatedRows = [] as ReduxQuoteInfo[]
    const updateAllCostlinepromises = []
    parsedQuoteInfo.map(costline => {
      if (costline.smg === null) {
        return costline
      }
      // Sets costline rate to smg if  rate doesn't exist or is 0
      if (!costline.rate && costline.smg) {
        costline.rate = costline.smg
        // We are keeping track of updated costlines in an array
        updatedRows.push(costline)
      }
      return costline
    })
    for (let i = 0; i < updatedRows.length; i++) {
      const updatePromise = async () => {
        const data = (await API.graphql(
          graphqlOperation(queries.getQuoteInfo, { id: updatedRows[i].id })
        )) as { data: GetQuoteInfoQueryApi }
        const originalRow = data.data.getQuoteInfo
        if (originalRow) {
          const updateDetails = {
            id: originalRow.id,
            rate: originalRow.smg,
            _version: originalRow._version,
          }
          const updatedRow = (await API.graphql(
            graphqlOperation(mutations.updateQuoteInfo, { input: updateDetails })
          )) as { data: UpdateQuoteInfoMutationApi }
          return updatedRow
        }
      }
      updateAllCostlinepromises.push(updatePromise())
    }
    await Promise.allSettled(updateAllCostlinepromises)
    dispatch(fetchQuoteInfo({ quoteId }))
    return
  } catch (err: any) {
    makeErrorToast(msg)
    return rejectWithValue(err)
  }
})

export const uploadQuote = createAsyncThunk<
  void,
  { quote: any; projectId: string },
  {
    state: RootState
    dispatch: ThunkAppDispatch
    rejectValue: string
  }
>('quote/uploadQuote', async ({ quote, projectId }, { getState, dispatch, rejectWithValue }) => {
  try {
    const parsedQuote: any = JSON.parse(quote)
    // Todo remove this any after auth slice has been changed to typescript
    const { userInfo }: any = getState().auth
    const tenantId = userInfo?.tenantId
    const {
      data: { getProjects: parsedParentProjectData },
    } = (await API.graphql(graphqlOperation(queries.getProjects, { id: projectId }))) as {
      data: GetProjectsQueryApi
    }
    const quoteId = nanoid()
    // * Get quote details working
    // ! field contact doesn't exist in schema when it's fixed remove it from the omit below
    let quoteDetails = omit(parsedQuote, [
      'quoteInfo',
      'recapInfo',
      'parentProjectId',
      'parentCompanyId',
      'createdAt',
      'updatedAt',
      'contact',
    ])
    // Add id equal to the new quoteId and omits the old _id
    quoteDetails.id = quoteId
    quoteDetails = omit(quoteDetails, ['_id'])
    quoteDetails.parentProjectId = projectId
    quoteDetails.tenantId = tenantId
    quoteDetails.type = 'quote'
    quoteDetails.activeFlag = true
    // * Assumption is all uploaded quotes have international
    quoteDetails.allowInternational = true
    await API.graphql(
      graphqlOperation(mutations.createQuote, {
        input: {
          ...quoteDetails,
          freelancers: ['dummyId'],
          childFreelancers: [...(parsedParentProjectData?.childFreelancers || ['dummyId'])],
          offlineIds: ['dummyId'],
        },
      })
    )

    // * Get quoteInfo working
    const quoteInfo: ReduxQuoteInfo[] = parsedQuote.quoteInfo
    // Adding empty costlines before the total of each subcategory and
    // adding agentCommission costline if it doesn't exist for that subcategory
    // Recalculate tableRowIndex and costlineIds and labels after that
    const quoteInfoWithAgentCommission = quoteInfo.reduce((finalArray: any[], item, index, arr) => {
      const prevItem = arr[index - 1]
      let agentCommissionCostline = []
      let categoryName = ''

      if (prevItem) {
        categoryName = prevItem.category as string
        categoryName = categoryName.replace(' - EXE', '')
      }
      if (item.costLineType === 'subCategoryTotal') {
        // Doesn't add a new empty costlines in these categories
        if (!['Insurance', 'Insurance - EXE'].includes(item.category as string)) {
          // Finds if agent Commission Costline exists for the subcategory if it doesn't we add it to empty costlines
          const agentCommissionRowIndex = quoteInfo.findIndex(
            r =>
              r.category === prevItem.category &&
              r.subCategory === prevItem.subCategory &&
              r.costLineType === 'costLine' &&
              r.item === 'Agent commission'
          )
          if (agentCommissionRowIndex === -1) {
            // Agent Commission line
            const otherAttributes = {
              activeFlag: true,
              item: 'Agent commission',
              item_fr: 'Commission agent',
              unit: 'Fee',
              marginPercentage: 0,
              overheadPercentage: 0,
              totalMargin: 0,
              allowMarginAndOverheadPercentageGlobalUpdate: false,
            }
            agentCommissionCostline.push({
              ...createCostLine(
                categoryName,
                prevItem.subCategory as string,
                prevItem.isInternational as boolean
              ),
              ...otherAttributes,
            })
          }
        }
      }
      if (agentCommissionCostline.length > 0) {
        finalArray = [...finalArray, ...agentCommissionCostline]
      }
      finalArray.push(item)
      return finalArray
    }, [])

    const updatedCostlinesWithLabels: any = createCostLineIdsAndLabels(quoteInfoWithAgentCommission)
    const idList = {} as any
    updatedCostlinesWithLabels.map((row: any) => {
      // The uploaded uuid is now the id
      const newId = nanoid()
      idList[row.uuid] = newId
      row.id = newId
      row.quoteId = quoteId
      row.tenantId = tenantId
      row.activeFlag = true
      delete row.uuid
      // Parse the attributes to covert text to number
      if (!row.quantity) row.quantity = checkNumber(row.quantity)
      if (!row.number) row.number = checkNumber(row.number)
      if (!row.rate) row.rate = checkNumber(row.rate)
      if (!row.total) row.total = checkNumber(row.total)
      if (!row.agentCommissionPercentage)
        row.agentCommissionPercentage = checkNumber(row.agentCommissionPercentage)
      if (!row.agentCommission) row.agentCommission = checkNumber(row.agentCommission)
      if (!row.marginPercentage) row.marginPercentage = checkNumber(row.marginPercentage)
      if (!row.overheadPercentage) row.overheadPercentage = checkNumber(row.overheadPercentage)
      if (!row.overtimeHoursCost) row.overtimeHoursCost = checkNumber(row.overtimeHoursCost)
      if (!row.overtimeHours) row.overtimeHours = checkNumber(row.overtimeHours)
      row.overtimeDetails.map((ot: any) => {
        if (!ot.overtimeHours) {
          ot.overtimeHours = checkNumber(ot.overtimeHours)
        }
      })
      return row
    })

    try {
      // Saves all the costline in the db one by one
      await Promise.all(
        updatedCostlinesWithLabels.map(async (item: any) => {
          await API.graphql(
            graphqlOperation(mutations.createQuoteInfo, {
              input: {
                ...item,
                freelancers: ['dummyId'],
                childFreelancers: [...(parsedParentProjectData?.childFreelancers || ['dummyId'])],
                offlineIds: ['dummyId'],
              },
            })
          )
        })
      )
    } catch (err: any) {
      // If any of the above costline fails we will get the Quote and delete it along with all related QuoteInfo costlines that were created
      let {
        data: { getQuote: deleteQuote },
      } = (await API.graphql(graphqlOperation(queries.getQuote, { id: quoteDetails.id }))) as {
        data: GetQuoteQueryApi
      }
      deleteQuote = checkIfQuoteIsAccessible(userInfo, deleteQuote)
      if (deleteQuote) {
        await API.graphql(graphqlOperation(mutations.deleteQuoteById, { quoteId: deleteQuote.id }))
      }

      makeErrorToast(msg)
    }
    const recapIdList: any = {}
    // * Get Recap Info Working
    const recapInfo: any = parsedQuote.recapInfo
    recapInfo.map((row: any) => {
      // tableRowIndex needs to be done first
      row.tableRowIndex = parseInt(row.id as string)
      const newId = nanoid()
      row.id = newId
      recapIdList[row.uuid as string] = newId
      // We update the uuid to the new random Id we created in quoteInfo above
      row.uuid = idList[row.uuid as string]
      row.quoteId = quoteId
      row.tenantId = tenantId
      row.activeFlag = true
      delete row.invoiceDocumentId
      // parse the numbers for empty strings and NaN
      if (!row.provisionalTotal) row.provisionalTotal = checkNumber(row.provisionalTotal)
      if (!row.actualTotal) row.actualTotal = checkNumber(row.actualTotal)
      return row
    })
    recapInfo.map((row: any) => {
      if (row.isCustomCostLine) {
        row.referenceCostLineUuid = recapIdList[row.referenceCostLineUuid]
      }
      return row
    })
    try {
      // Saves all the costline in the db one by one
      await Promise.all(
        recapInfo.map(async (item: any) => {
          await API.graphql(
            graphqlOperation(mutations.createRecapInfo, {
              input: {
                ...item,
                freelancers: ['dummyId'],
                childFreelancers: [...(parsedParentProjectData?.childFreelancers || ['dummyId'])],
                offlineIds: ['dummyId'],
              },
            })
          )
        })
      )
    } catch (err: any) {
      // If any of the above costline fails we will get the Quote and delete it along with all related QuoteInfo costlines that were created
      let {
        data: { getQuote: deleteQuote },
      } = (await API.graphql(graphqlOperation(queries.getQuote, { id: quoteDetails.id }))) as {
        data: GetQuoteQueryApi
      }
      deleteQuote = checkIfQuoteIsAccessible(userInfo, deleteQuote)

      if (deleteQuote) {
        await API.graphql(graphqlOperation(mutations.deleteQuoteById, { quoteId: deleteQuote.id }))
      }
      makeErrorToast(msg)
    }
    // * Fetch Project Children
    dispatch(fetchProjectChildren({ parentProjectId: projectId }))
  } catch (err: any) {
    makeErrorToast(msg)
    return rejectWithValue(err)
  }
})

export const getOfflineQuotes = createAsyncThunk<
  ReduxQuote,
  { userId: string },
  {
    state: RootState
    rejectValue: string
  }
>('quote/getOfflineQuotes', async (arg, { getState, rejectWithValue }) => {
  try {
    const { auth } = getState()

    const quoteDetails = await DataStore.query(Quote, item =>
      item.offlineIds('contains', auth.userInfo.username).activeFlag('eq', true)
    )

    const parsedQuote = JSON.parse(JSON.stringify(quoteDetails))
    // const accessibleQuote: ReduxQuote = checkIfQuoteIsAccessible(auth.userInfo, parsedQuote[0])
    // if (accessibleQuote) {
    //   return accessibleQuote as ReduxQuote
    // } else {
    //   makeErrorToast(msg)
    //   return rejectWithValue('Error Fetching Quote')
    // }
    return parsedQuote
  } catch (err: any) {
    makeErrorToast(msg)
    return rejectWithValue(err)
  }
})

export const quoteSlice = createSlice({
  name: 'quote',
  initialState,
  reducers: {
    setFetchRecapQuoteInfoApiStatus: (state, action) => {
      state.fetchRecapQuoteInfoApiStatus = action.payload.status
    },
    setSummaryFetchQuoteStatus: (state, action) => {
      state.summaryFetchQuoteStatus = action.payload.status
    },
    setAddQuoteModalOpenStatus: (state, action) => {
      state.addQuoteModalOpenStatus = action.payload.status
    },
    setQuoteDeleteDialogOpenStatus: (state, action) => {
      state.quoteDeleteDialogOpenStatus = action.payload.status
      state.currentQuote = action.payload.quote
    },
    setUpdateQuoteInfoLoadingStatus: (state, action) => {
      state.updateQuoteInfoApiStatus = action.payload
    },
    setUpdateQuoteInfoDebounceApiStatus: (state, action) => {
      state.updateQuoteInfoDebounceApiStatus = action.payload
    },
    setUpdateRecapQuoteInfoDebounceApiStatus: (state, action) => {
      state.updateRecapQuoteInfoDebounceApiStatus = action.payload
    },
    setUpdateRecapQuoteInfoLoadingStatus: (state, action) => {
      state.updateRecapQuoteInfoApiStatus = action.payload
    },
    clearQuote: (state, action: PayloadAction<void>) => {
      state.quoteInfo = []
      state.recapQuoteInfo = []
      state.currentQuote = null
      state.maximizeMinimize = 'maximize'
      state.scrollToCategory = null
      state.calculateRecapInfoStatus = false
    },
    clearQuoteInfo: (state, action: PayloadAction<void>) => {
      state.quoteInfo = []
    },
    clearRecapQuoteInfo: (state, action: PayloadAction<void>) => {
      state.recapQuoteInfo = []
      state.calculateRecapInfoStatus = false
    },
    setQuoteSummaryTotalsModalOpenStatus: (state, action) => {
      state.quoteSummaryTotalsModalOpenStatus = action.payload
    },
    setRecapSummaryTotalsModalOpenStatus: (state, action) => {
      state.recapSummaryTotalsModalOpenStatus = action.payload
    },
    setScrollToCategoryModalOpenStatus: (state, action) => {
      state.scrollToCategoryModalOpenStatus = action.payload
    },
    setQuotePdfGeneratorModalOpenStatus: (state, action) => {
      state.quotePdfGeneratorModalOpenStatus = action.payload
    },
    setRecapQuotePdfModalOpenStatus: (state, action) => {
      state.recapQuotePdfModalOpenStatus = action.payload
    },
    setQuoteDuplicateDialogOpenStatus: (state, action) => {
      state.quoteDuplicateDialogOpenStatus = action.payload
    },
    setQuoteMoveDialogOpenStatus: (state, action) => {
      state.quoteMoveDialogOpenStatus = action.payload
    },
    setQuoteSmgDialogStatus: (state, action) => {
      state.quoteSmgDialogStatus = action.payload
    },
    setQuoteEditModalStatus: (state, action) => {
      state.quoteEditModalStatus = action.payload
    },
    setScrollToQuoteCategory: (state, action) => {
      state.scrollToCategory = action.payload
    },
    setMinimize: state => {
      state.maximizeMinimize = 'minimize'
    },
    setMaximize: state => {
      state.maximizeMinimize = 'maximize'
    },
    setMaximizeMinimize: state => {
      if (state.maximizeMinimize === 'minimize') {
        state.maximizeMinimize = 'maximize'
      } else {
        state.maximizeMinimize = 'minimize'
      }
    },
    setGridFilters: (state, action) => {
      state.filters = action.payload
    },
    setClearFilters: state => {
      state.filters = {
        item: '',
        item_fr: '',
        quantity: 0,
        number: 0,
        unit: '',
        rate: 0,
        rateInEuros: 0,
        total: 0,
        payrollTaxType: '',
        payrollTaxEnabled: '',
        agentCommissionPercentage: 0,
        marginPercentage: 0,
        overheadPercentage: 0,
        totalMargin: 0,
      }
    },
    setGridExpandedRows: (state, action) => {
      state.expandedRows = action.payload
    },
    setCurrentQuote: (state, action) => {
      state.currentQuote = action.payload
    },
    setQuoteInfo: (state, action) => {
      state.quoteInfo = action.payload
    },
    setRecapQuoteInfo: (state, action) => {
      state.recapQuoteInfo = action.payload
    },
    setSmgMenuAnchorEl: (state, action) => {
      state.smgMenuAnchorEl = action.payload
    },
    setEditQuoteMenuAnchorEl: (state, action) => {
      state.editQuoteMenuAnchorEl = action.payload
    },
    updateSingleRecapCostline: (state, action) => {
      const index = action.payload.tableRowIndex
      state.recapQuoteInfo[index] = action.payload
    },
    setGetOfflineQuotesApiStatus: (state, action) => {
      state.getOfflineQuotesApiStatus = 'loading'
    },
    clearOfflineQuotes: (state, action) => {
      state.offlineQuotes = []
    },
  },
  extraReducers: builder => {
    builder.addCase(fetchQuote.pending, (state, action) => {
      state.fetchQuoteApiStatus = 'loading'
      if (action.meta.arg.page === 'quoteCard') {
        state.summaryFetchQuoteStatus = 'loading'
      }
    })
    builder.addCase(fetchQuote.fulfilled, (state, action) => {
      state.fetchQuoteApiStatus = 'succeeded'
      if (
        (action.payload.maximizeMinimize === 'maximize' ||
          action.payload.maximizeMinimize === 'minimize') &&
        action.meta.arg.status === 'pageLoad'
      ) {
        state.maximizeMinimize = action.payload.maximizeMinimize
      }
      state.currentQuote = action.payload
    })
    builder.addCase(fetchQuote.rejected, (state, action) => {
      state.fetchQuoteApiStatus = 'failed'
      state.error = action.error.message
    })
    builder.addCase(fetchQuoteInfo.pending, (state, action) => {
      state.fetchQuoteInfoApiStatus = 'loading'
    })
    builder.addCase(fetchQuoteInfo.fulfilled, (state, action) => {
      state.fetchQuoteInfoApiStatus = 'succeeded'
      state.quoteInfo = action.payload
      state.oldQuoteInfo = action.payload
      state.updateQuoteInfoApiStatus = 'succeeded'
      if (action.meta.arg.page === 'quoteCard') {
        state.summaryFetchQuoteStatus = 'succeeded'
      }
    })
    builder.addCase(fetchQuoteInfo.rejected, (state, action) => {
      state.fetchQuoteInfoApiStatus = 'failed'
      state.error = action.error.message
      state.updateQuoteInfoApiStatus = 'failed'
    })
    builder.addCase(fetchRecapQuoteInfo.pending, (state, action) => {
      state.fetchRecapQuoteInfoApiStatus = 'loading'
    })
    builder.addCase(fetchRecapQuoteInfo.fulfilled, (state, action) => {
      state.fetchRecapQuoteInfoApiStatus = 'succeeded'
      state.updateRecapQuoteInfoApiStatus = 'succeeded'
      if (action.payload) {
        state.recapQuoteInfo = action.payload
        state.oldRecapQuoteInfo = action.payload
      }
      if (action.meta.arg.calculateRecapInfo) {
        state.calculateRecapInfoStatus = true
      }
    })
    builder.addCase(fetchRecapQuoteInfo.rejected, (state, action) => {
      state.fetchRecapQuoteInfoApiStatus = 'failed'
      state.error = action.error.message
    })
    builder.addCase(createQuote.pending, (state, action) => {
      state.createOrUpdateQuoteApiStatus = 'loading'
    })
    builder.addCase(createQuote.fulfilled, (state, action) => {
      state.createOrUpdateQuoteApiStatus = 'succeeded'
      state.addQuoteModalOpenStatus = false
    })
    builder.addCase(createQuote.rejected, (state, action) => {
      state.createOrUpdateQuoteApiStatus = 'failed'
      state.addQuoteModalOpenStatus = false
      state.error = action.error?.message
      if (action.payload) {
        state.error = action.payload
      }
    })
    builder.addCase(updateQuote.pending, (state, action) => {
      state.createOrUpdateQuoteApiStatus = 'loading'
    })
    builder.addCase(updateQuote.fulfilled, (state, action) => {
      state.createOrUpdateQuoteApiStatus = 'succeeded'
      state.quoteEditModalStatus = { isOpen: false }
    })
    builder.addCase(updateQuote.rejected, (state, action) => {
      state.createOrUpdateQuoteApiStatus = 'rejected'
      state.quoteEditModalStatus = { isOpen: false }
      state.error = action.error?.message
    })
    builder.addCase(toggleQuoteOffline.pending, (state, action) => {
      state.updateOfflineIdsStatus = 'loading'
    })
    builder.addCase(toggleQuoteOffline.fulfilled, (state, action) => {
      state.updateOfflineIdsStatus = 'succeeded'
    })
    builder.addCase(toggleQuoteOffline.rejected, (state, action) => {
      state.updateOfflineIdsStatus = 'rejected'
      state.error = action.error?.message
    })
    builder.addCase(updateQuoteInfo.pending, (state, action) => {
      ++state.updateQuoteInfoApiCounter
      state.updateQuoteInfoDebounceApiStatus = 'loading'
    })
    builder.addCase(updateQuoteInfo.fulfilled, (state, action) => {
      state.oldQuoteInfo = [...action.payload]
      --state.updateQuoteInfoApiCounter
      state.updateQuoteInfoDebounceApiStatus = 'succeeded'
    })
    builder.addCase(updateQuoteInfo.rejected, (state, action) => {
      state.error = action.error.message
      state.quoteInfo = [...state.oldQuoteInfo]
      --state.updateQuoteInfoApiCounter
      state.updateQuoteInfoDebounceApiStatus = 'rejected'
    })
    builder.addCase(addQuoteInfoCostline.rejected, (state, action) => {
      state.error = action.error.message
      state.quoteInfo = [...state.oldQuoteInfo]
      state.updateQuoteInfoApiStatus = 'rejected'
    })
    builder.addCase(addRecapQuoteInfoCostline.fulfilled, (state, action) => {
      state.oldRecapQuoteInfo = [...action.payload]
      state.recapQuoteInfo = [...action.payload]
      state.updateRecapQuoteInfoApiStatus = 'succeeded'
    })

    builder.addCase(addRecapQuoteInfoCostline.rejected, (state, action) => {
      state.error = action.error.message
      state.recapQuoteInfo = [...state.oldRecapQuoteInfo]
      state.updateRecapQuoteInfoApiStatus = 'rejected'
    })
    builder.addCase(updateRecapQuoteInfo.pending, (state, action) => {
      ++state.updateRecapQuoteInfoApiCounter
      state.updateRecapQuoteInfoDebounceApiStatus = 'loading'
    })
    builder.addCase(updateRecapQuoteInfo.fulfilled, (state, action) => {
      state.oldRecapQuoteInfo = [...action.payload]
      state.updateRecapQuoteInfoDebounceApiStatus = 'succeeded'
      --state.updateRecapQuoteInfoApiCounter
      state.updateRecapQuoteInfoApiStatus = 'succeeded'
    })
    builder.addCase(updateRecapQuoteInfo.rejected, (state, action) => {
      state.error = action.error.message
      state.recapQuoteInfo = [...state.oldRecapQuoteInfo]
      state.updateRecapQuoteInfoDebounceApiStatus = 'rejected'
      --state.updateRecapQuoteInfoApiCounter
      state.updateRecapQuoteInfoApiStatus = 'rejected'
    })
    builder.addCase(deleteQuote.pending, (state, action) => {
      state.deleteQuoteApiStatus = 'loading'
    })
    builder.addCase(deleteQuote.fulfilled, (state, action) => {
      state.deleteQuoteApiStatus = 'succeeded'
      state.quoteDeleteDialogOpenStatus = false
    })
    builder.addCase(deleteQuote.rejected, (state, action) => {
      state.deleteQuoteApiStatus = 'failed'
      state.quoteDeleteDialogOpenStatus = false
      state.error = action.error.message
    })
    builder.addCase(refreshRecapQuoteInfo.pending, (state, action) => {
      state.refreshRecapQuoteInfoApiStatus = 'loading'
    })
    builder.addCase(refreshRecapQuoteInfo.fulfilled, (state, action) => {
      state.refreshRecapQuoteInfoApiStatus = 'succeeded'
    })
    builder.addCase(refreshRecapQuoteInfo.rejected, (state, action) => {
      state.refreshRecapQuoteInfoApiStatus = 'rejected'
    })
    builder.addCase(duplicateQuote.pending, (state, action) => {
      state.duplicateQuoteApiStatus = 'loading'
    })
    builder.addCase(duplicateQuote.fulfilled, (state, action) => {
      state.duplicateQuoteApiStatus = 'succeeded'
      state.quoteDuplicateDialogOpenStatus = false
    })
    builder.addCase(duplicateQuote.rejected, (state, action) => {
      state.duplicateQuoteApiStatus = 'rejected'
      state.quoteDuplicateDialogOpenStatus = false
      state.error = action.error?.message
      if (action.payload) {
        state.error = action.payload
      }
    })
    builder.addCase(moveQuote.pending, (state, action) => {
      state.moveQuoteApiStatus = 'loading'
    })
    builder.addCase(moveQuote.fulfilled, (state, action) => {
      state.moveQuoteApiStatus = 'succeeded'
      state.quoteMoveDialogOpenStatus = false
    })
    builder.addCase(moveQuote.rejected, (state, action) => {
      state.moveQuoteApiStatus = 'rejected'
      state.quoteMoveDialogOpenStatus = false
      state.error = action.error?.message
      if (action.payload) {
        state.error = action.payload
      }
    })
    builder.addCase(removeQuoteSmg.pending, (state, action) => {
      state.addOrRemoveSmgQuoteApiStatus = 'loading'
    })
    builder.addCase(removeQuoteSmg.fulfilled, (state, action) => {
      state.addOrRemoveSmgQuoteApiStatus = 'succeeded'
      state.quoteSmgDialogStatus = { isOpen: false, section: null }
    })
    builder.addCase(removeQuoteSmg.rejected, (state, action) => {
      state.addOrRemoveSmgQuoteApiStatus = 'rejected'
      state.quoteSmgDialogStatus = { isOpen: false, section: null }
      state.error = action.error?.message
    })
    builder.addCase(addQuoteSmg.pending, (state, action) => {
      state.addOrRemoveSmgQuoteApiStatus = 'loading'
    })
    builder.addCase(addQuoteSmg.fulfilled, (state, action) => {
      state.addOrRemoveSmgQuoteApiStatus = 'succeeded'
      state.quoteSmgDialogStatus = { isOpen: false, section: null }
    })
    builder.addCase(addQuoteSmg.rejected, (state, action) => {
      state.addOrRemoveSmgQuoteApiStatus = 'rejected'
      state.quoteSmgDialogStatus = { isOpen: false, section: null }
      state.error = action.error?.message
    })
    builder.addCase(uploadQuote.pending, (state, action) => {
      state.uploadQuoteApiStatus = 'loading'
    })
    builder.addCase(uploadQuote.fulfilled, (state, action) => {
      state.uploadQuoteApiStatus = 'succeeded'
      state.quoteMoveDialogOpenStatus = false
    })
    builder.addCase(uploadQuote.rejected, (state, action) => {
      state.uploadQuoteApiStatus = 'rejected'
      state.quoteMoveDialogOpenStatus = false
      state.error = action.error?.message
      if (action.payload) {
        state.error = action.payload
      }
    })

    builder.addCase(getOfflineQuotes.pending, (state, action) => {
      state.getOfflineQuotesApiStatus = 'loading'
    })
    builder.addCase(getOfflineQuotes.fulfilled, (state, action) => {
      state.getOfflineQuotesApiStatus = 'succeeded'
      state.offlineQuotes = action.payload
    })
    builder.addCase(getOfflineQuotes.rejected, (state, action) => {
      state.getOfflineQuotesApiStatus = 'rejected'
      state.error = action.error?.message
      if (action.payload) {
        state.error = action.payload
      }
    })
  },
})

export const {
  setFetchRecapQuoteInfoApiStatus,
  setSummaryFetchQuoteStatus,
  setAddQuoteModalOpenStatus,
  setQuoteDeleteDialogOpenStatus,
  setUpdateQuoteInfoLoadingStatus,
  setUpdateQuoteInfoDebounceApiStatus,
  setUpdateRecapQuoteInfoDebounceApiStatus,
  setUpdateRecapQuoteInfoLoadingStatus,
  clearQuote,
  clearQuoteInfo,
  clearRecapQuoteInfo,
  setQuoteSummaryTotalsModalOpenStatus,
  setRecapSummaryTotalsModalOpenStatus,
  setScrollToCategoryModalOpenStatus,
  setQuotePdfGeneratorModalOpenStatus,
  setRecapQuotePdfModalOpenStatus,
  setQuoteDuplicateDialogOpenStatus,
  setQuoteMoveDialogOpenStatus,
  setQuoteSmgDialogStatus,
  setQuoteEditModalStatus,
  setScrollToQuoteCategory,
  setMinimize,
  setMaximize,
  setMaximizeMinimize,
  setGridFilters,
  setClearFilters,
  setGridExpandedRows,
  setCurrentQuote,
  setQuoteInfo,
  setRecapQuoteInfo,
  setSmgMenuAnchorEl,
  setEditQuoteMenuAnchorEl,
  updateSingleRecapCostline,
  setGetOfflineQuotesApiStatus,
  clearOfflineQuotes,
} = quoteSlice.actions

// export default quoteSlice.reducer
export default quoteSlice.reducer as Reducer<QuoteState>
